export const ONRAMPER_THEME_DARK = {
  theme: 'dark',
  primaryColor: 'EFD43C',
  secondaryColor: '2E2E2E',
  primaryTextColor: 'FFFFFF',
  secondaryTextColor: '969696',
  primaryBtnTextColor: '000000',
  containerColor: '1E1E1E',
  cardColor: '2E2E2E'
}

export const ONRAMPER_THEME_LIGHT = {
  theme: 'light',
  primaryColor: 'CB7D00',
  secondaryColor: 'F5F5F5',
  primaryTextColor: '1A1A1A',
  secondaryTextColor: '6B758B',
  primaryBtnTextColor: 'FFFFFF',
  containerColor: 'FFFFFF',
  cardColor: 'F6F7F9'
}

const ONRAMPER_CRYPTO_ID_BY_CODE = {
  BTC: 'btc',
  ETH: 'eth',
  SOL: 'sol',
  LTC: 'ltc_litecoin',
  DOGE: 'doge_dogecoin',
  USDT: 'usdt_ethereum',
  USDT_ERC20: 'usdt_ethereum',
  'USDT.TRC20': 'usdt_tron',
  'USDT.BEP20': 'usdt_bsc',
  'USDT.POL': 'usdt_polygon',
  'USDT.SOL': 'usdt_solana',
  'USDC.TRC20': 'usdc_tron',
  'USDC.ERC20': 'usdc_ethereum',
  USDC: 'usdc_ethereum',
  'BNB.BSC': 'bnb_bsc',
  BNB: 'bnb_bsc',
  XRP: 'xrp',
  TRX: 'trx_tron',
  'MATIC.POLY': 'matic_polygon'
}

const ONRAMPER_SKIP_WALLET_CODES = new Set([
  'LTCT',
  'LTC_TEST',
  'BTC_TEST',
  'ETH_TEST5',
  'SOL_TEST'
])

export const shouldAttachOnramperWallet = (currencyCode) => {
  if (!currencyCode) return true
  return !ONRAMPER_SKIP_WALLET_CODES.has(String(currencyCode).trim().toUpperCase())
}

export const isAppDarkMode = () => {
  if (typeof document === 'undefined') return true

  const root = document.documentElement
  const { body } = document

  const explicitLight =
    root.classList.contains('light') ||
    body.classList.contains('light') ||
    root.getAttribute('data-theme') === 'light' ||
    body.getAttribute('data-theme') === 'light'

  if (explicitLight) return false

  const explicitDark =
    root.classList.contains('dark') ||
    body.classList.contains('dark') ||
    root.getAttribute('data-theme') === 'dark' ||
    body.getAttribute('data-theme') === 'dark' ||
    body.classList.contains('prediction-market-open') ||
    !!document.querySelector('.prediction-market-page.dark')

  if (explicitDark) return true

  if (window.matchMedia?.('(prefers-color-scheme: light)').matches) {
    return false
  }

  return true
}

export const getOnramperThemeParams = () => (
  isAppDarkMode() ? ONRAMPER_THEME_DARK : ONRAMPER_THEME_LIGHT
)

export const toOnramperCryptoId = (currencyCode) => {
  if (!currencyCode) return null
  const normalized = String(currencyCode).trim()
  if (ONRAMPER_SKIP_WALLET_CODES.has(normalized.toUpperCase())) return null
  const mapped = ONRAMPER_CRYPTO_ID_BY_CODE[normalized] ||
    ONRAMPER_CRYPTO_ID_BY_CODE[normalized.toUpperCase()]
  if (mapped) return mapped

  const upper = normalized.toUpperCase()
  if (upper.includes('USDT') && upper.includes('SOL')) return 'usdt_solana'
  if (upper.includes('USDT') && (upper.includes('ERC') || upper.includes('ETH'))) return 'usdt_ethereum'
  if (upper.includes('USDT') && upper.includes('TRC')) return 'usdt_tron'
  if (upper.includes('USDC') && upper.includes('TRC')) return 'usdc_tron'
  if (upper.includes('USDC')) return 'usdc_ethereum'
  if (upper === 'XRP') return 'xrp'
  if (upper === 'TRX') return 'trx_tron'
  if (upper.includes('BNB')) return 'bnb_bsc'
  if (upper === 'DOGE') return 'doge_dogecoin'

  return null
}
